import gameAssets from "@themed-assets";
import ChevronLeft from "@/src/assets/ChevronLeft";
import React from "react";
import { Drawer, DrawerContent, DrawerTrigger } from "../ui/drawer";

function TourneyDetailsBountyInfo() {
  return (
    <Drawer>
      <div>
        <div className="flex justify-between items-center text-sm text-primary font-bold">
          <div className={``}>Mystery Bounty</div>
          <DrawerTrigger>
            <div className="text-success border-b border-success">Rules</div>
          </DrawerTrigger>
        </div>

        <div className="bg-foreground p-3 rounded mt-3">
          <div className="flex flex-wrap text-sm font-medium">
            {bountyObj.map((item, key) => (
              <div className="w-1/3 flex flex-col items-center justify-center mb-3">
                <img src={gameAssets[item.asset]} />
                <div className="">₹ {item.amount}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <DrawerContent className={`bg-foreground`}>
        <div className=" bg-foreground rounded p-4">
          <div className="flex items-center">
            <ChevronLeft width={8} height={14} />
            <div className="text-sm font-bold text-primary ml-2">
              Mystery Bounty Rules
            </div>
          </div>
          {rulesObj.map((item, key) => (
            <div className="flex text-sm font-medium text-secondary mt-2">
              <div>{item.number}.</div>
              <div className="text-sm  ml-2">{item.rule}</div>
            </div>
          ))}
        </div>
      </DrawerContent>
    </Drawer>
  );
}

export default TourneyDetailsBountyInfo;

const rulesObj = [
  {
    number: 1,
    rule: "Mystery Bounty is a special type of K.O. Bounty MTT. The prize pool in a Mystery Bounty MT is divided into two separate pools: a bounty prize pool and a ranking prize pool.",
  },
  {
    number: 2,
    rule: "In Mystery Bounty MTTs, players will not receive any bounty prizes for eliminating opponents before reaching the ITM stage. ITM players will get a chance to draw a bounty for every opponent they eliminate. Bounty values are random, and players will not know how much they will get before drawing for a bounty reward.",
  },
  {
    number: 3,
    rule: "If multiple players eliminate the same player, the bounty will be split among them evenly.",
  },
  {
    number: 4,
    rule: "Players may check the amount remaining in the bounty prize pool and the history of awarded bounties by tapping on the Mystery Bounty icon at the table.",
  },
];

const bountyObj = [
  {
    asset: "Bounty50K",
    amount: "50,000",
  },
  {
    asset: "Bounty40K",
    amount: "40,000",
  },
  {
    asset: "Bounty30K",
    amount: "30,000",
  },
  {
    asset: "Bounty20K",
    amount: "20,000",
  },
  {
    asset: "Bounty10K",
    amount: "10,000",
  },
  {
    asset: "Bounty8K",
    amount: "8,000",
  },
  {
    asset: "BountyOthers",
    amount: "60,000",
  },
];
